// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3KkMJ","newExpiryDate":"styles_newExpiryDate__3UOVh","footer":"styles_footer__Rpz3f"};